// plugins/font-face.ts
import { ASS } from "../index.js";
import "./index.js";
var FontFacePlugin = class {
  matchModifier(path) {
    return Array.isArray(path) ? path.some((pathPart) => pathPart === "@font-face") : path === "@font-face";
  }
  generateFlattenedStyle(pathStyle, flattenedStyle) {
    const fontFaceIndex = pathStyle.path.findIndex((pathPart) => pathPart === "@font-face");
    if (fontFaceIndex !== -1) {
      if (!flattenedStyle["@font-face"])
        flattenedStyle["@font-face"] = [];
      flattenedStyle["@font-face"].push(pathStyle.style);
      return true;
    }
    return false;
  }
  generateStyleSheetRule(_, styles, sheet) {
    styles.forEach((fontFace) => sheet.insertRule(ASS.stringifyRule({ "@font-face": fontFace }), sheet.cssRules.length));
    return true;
  }
};
export {
  FontFacePlugin
};
